import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { ISelectOption } from 'src/app/models/selectOptions';
import { ITableRowViewModel } from 'src/app/models/viewModels';

@Pipe({
  name: 'selectOptionTableCell',
})
export class SelectOptionTableCellPipe implements PipeTransform {
  public transform(
    dict: { [key: string]: ISelectOption } | ITableRowViewModel,
    propertyName: string
  ): null | ISelectOption {
    const value = _.get(dict, propertyName);
    if (value === undefined) {
      return null;
    }

    return value;
  }
}
